import React, { useEffect, useState } from 'react';
import { getAuth, isSignInWithEmailLink, signInWithEmailLink, createUserWithEmailAndPassword } from "firebase/auth";

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const auth = getAuth();
    if (isSignInWithEmailLink(auth, window.location.href)) {
      const storedEmail = window.localStorage.getItem('emailForSignIn');
      if (storedEmail) {
        setEmail(storedEmail);
      }
    }
  }, []);

  const handleSignUp = async () => {
    const auth = getAuth();
    try {
      await signInWithEmailLink(auth, email, window.location.href);
      await createUserWithEmailAndPassword(auth, email, password);
      setMessage('アカウントの作成に成功しました！');
      window.localStorage.removeItem('emailForSignIn');
    } catch (error) {
      setMessage('アカウント作成に失敗しました: ' + error.message);
    }
  };

  return (
    <div>
      <h1>新規登録</h1>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="メールアドレス"
        disabled
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="パスワード"
      />
      <button onClick={handleSignUp}>登録</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default SignUp;
